import { TextBody, Icon, IconName, Col, TextLabel } from "../lib";

type Props = {
  active?: boolean;
  icon: IconName;
  title: string;
  value: string | number;
};

export function DetailIcon({ active = false, icon, title, value }: Props) {
  return (
    <Col.C>
      <TextLabel mb="1" small center>
        {title}
      </TextLabel>
      <Icon name={icon} color={active ? "accent" : "onSurfaceDim"} />
      <TextBody mt="1" numberOfLines={1} small>
        {value}
      </TextBody>
    </Col.C>
  );
}
